module.exports = __webpack_public_path__ + "img/4h.1ddbae88.png";